var map = {
	"./awe.jpg": 2062,
	"./awesmall.jpg": 557,
	"./bluebird.jpg": 2130,
	"./bluebirdsmall.jpg": 5633,
	"./img1.jpg": 3701,
	"./img1small.jpg": 8252,
	"./img2.jpg": 9498,
	"./img2small.jpg": 489,
	"./img3.jpg": 663,
	"./img3small.jpg": 6870,
	"./img4.jpg": 700,
	"./img4small.jpg": 6523,
	"./kuhn.jpg": 6697,
	"./kuhnsmall.jpg": 368,
	"./readme.jpg": 7173,
	"./readmesmall.jpg": 7276,
	"./topia.jpg": 1912,
	"./topiasmall.jpg": 3207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6540;